import React from 'react';
import { FaAward, FaUsers, FaTrophy } from 'react-icons/fa';

export default function About() {
  return (
    <section id="about" className="section">
      <div className="about-container">
        <div className="about-content">
          <h2>About Rudra Sports</h2>
          <p>
            Welcome to Rudra Sports - Your Premier Sports Destination. We are committed to 
            providing world-class facilities for badminton, box cricket, and fitness training.
          </p>
          <p>
            With over 10 years of experience, we've built a community of passionate sports 
            enthusiasts. Our state-of-the-art facilities and experienced coaches ensure 
            every member gets the best experience possible.
          </p>
          <p>
            Whether you're a beginner or a seasoned player, we have something for everyone. 
            Join us and be part of a thriving sports community!
          </p>

          <ul className="about-list">
            <li>Professional-grade courts and equipment</li>
            <li>Expert coaches and trainers</li>
            <li>Active tournament organization</li>
            <li>Community-focused environment</li>
            <li>Flexible membership options</li>
            <li>Modern facilities with excellent maintenance</li>
          </ul>
        </div>

        <div>
          <div className="about-image">
            <span style={{ fontSize: '2em', marginRight: '1rem' }}>🏆</span>
          </div>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr', 
            gap: '1rem',
            marginTop: '2rem'
          }}>
            <div style={{
              background: 'rgba(255, 255, 255, 0.1)',
              padding: '1.5rem',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <FaAward size={2} style={{ color: 'var(--accent-color)', marginBottom: '0.5rem' }} />
              <h4 style={{ marginTop: '0.5rem' }}>500+ Active Members</h4>
            </div>
            <div style={{
              background: 'rgba(255, 255, 255, 0.1)',
              padding: '1.5rem',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <FaUsers size={2} style={{ color: 'var(--accent-color)', marginBottom: '0.5rem' }} />
              <h4 style={{ marginTop: '0.5rem' }}>10+ Tournaments/Year</h4>
            </div>
            <div style={{
              background: 'rgba(255, 255, 255, 0.1)',
              padding: '1.5rem',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <FaTrophy size={2} style={{ color: 'var(--accent-color)', marginBottom: '0.5rem' }} />
              <h4 style={{ marginTop: '0.5rem' }}>10+ Years Experience</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
